import {
  EnrichedDevice,
  EnrichedEntity,
  EntityType,
} from '@eppendorf/vnls-audit-event-client';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

export function SimpleDeviceDisplay({ device }: { device?: EnrichedEntity[] }) {
  const { t } = useTranslation();
  const devices = (device?.filter((d) => d.type === 'device') as EnrichedDevice[]) ?? [];

  if (!devices.length) {
    devices.push({
      type: EntityType.Device,
      serialNumber: t('shared.unknown'),
      name: t('shared.unknown'),
      registrationNumber: t('shared.unknown'),
    });
  }

  return (
    <div className="flex flex__dir--column gap-s">
      {devices.map((d) => (
        <div key={d.serialNumber} className="flex flex__dir--row flex__ai--center gap-s">
          <Icon name="generic" size={IconSizeClasses.Small} />
          <div className="flex flex__dir--column">
            <div className="font-weight-bold">{d.name || t('shared.unknown')}</div>
            <div className="color-gray-800">{d.serialNumber || t('shared.unknown')}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
